export * from "@workspace/gamja-platform/components/exam-score";
